

export default {
	name: 'bill-query-result',
	mixins: [],
	extends: {},
	components: {},
	props: ['monthText', 'billNo', 'billMonth'],
	data() {
		return {};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		init(){
			if(!this.monthText || !this.billNo || !this.billMonth){
				this.$router.push({name: 'bill-query-month'});
			}
		},
		getPdf(){
			let params = {
				'billNo': this.billNo,
				'billMonth': this.billMonth,
			}
			let queryString = $.param(params);
			let url = process.env.BASE_URL+"/BillQueryMonth/api/outputFile?"+queryString;
			window.location.href=url;
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/billQuery/billQueryResult.js